import React from 'react';
import Toolbar from '@material-ui/core/Toolbar';
import PropTypes from 'prop-types';
import history from 'store/history';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import _ from 'lodash';
import Searcher from 'components/Searcher';
import '../styles.css';
import {
  AppHeader, BreadcrumbElement, Breadcrumb, SearcherIcon,
  LogoutButton,
} from './styles';
import {
  ROUTE_PROFILE, ROUTE_THINK, ROUTE_LOGOUT, ROUTE_THINK_SEED_CREATION,
} from '../../../constants/urls';

class Navbar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showSearcher: false,
    };
  }

  handleClick = () => {
    history.push(ROUTE_PROFILE);
  };

  printBreadCrumb = () => {
    const { navbarData: { breadcrumb }, actualContext, app } = this.props;

    let i = 0;
    return _.map(breadcrumb, (element) => {
      if (!element) {
        return null;
      }
      const { text, color, onClick } = element;
      let finalColor = color;

      if (actualContext && typeof actualContext.color !== 'undefined' && typeof app.advanced_configuration !== 'undefined' && typeof app.advanced_configuration.no_background_color !== 'undefined' && app.advanced_configuration.no_background_color) {
        finalColor = typeof actualContext.color === 'string' ? actualContext.color : actualContext.color.color;
      }

      const textElement = i ? `/ ${text}` : text;
      i += 1;
      return (
        <BreadcrumbElement key={i} color={finalColor} onClick={onClick} dangerouslySetInnerHTML={{ __html: textElement }} />
      );
    });
  }

  getColor = () => {
    const { app, actualContext } = this.props;
    if (!actualContext) {
      return app.color1;
    }
    switch (actualContext.elementType) {
      case 'narrative':
      case 'objective':
        return actualContext.color;
      default:
        return app.color1;
    }
  }

  goToMessages = () => {
    history.push(ROUTE_THINK);
  }

  handleLogout = () => {
    history.push(ROUTE_LOGOUT);
  }

  goToCreationThinkSeed = () => {
    history.push(ROUTE_THINK_SEED_CREATION);
  }

  handleCloseSelectedUser = () => {
    const { viewUserProfile } = this.props;
    viewUserProfile(0);
  }

  handleToggleSearcher = () => {
    const { showSearcher } = this.state;

    this.setState({ showSearcher: !showSearcher });
  }

  printCreationThinkSeed = () => {
    return (<AddCircleIcon fontSize='large' onClick={this.goToCreationThinkSeed} />);
  }

  render() {
    const {
      searcher, logoutVisible, literals, creationThinkSeed,
    } = this.props;
    const { showSearcher } = this.state;
    const color = this.getColor();
    return (
      <React.Fragment>
        {showSearcher && (<Searcher onClose={this.handleToggleSearcher} />)}

        <AppHeader position='static' className='Navbar' color='default'>
          <Toolbar className='Navbar--top'>
            {searcher && (
              <SearcherIcon color={color || color.color} onClick={this.handleToggleSearcher}>
                <i className='fa fa-search' />
              </SearcherIcon>
            )}
            <Breadcrumb className='grow text-align-left Navbar--top--title'>
              {this.printBreadCrumb()}
              {logoutVisible ? (
                <LogoutButton onClick={this.handleLogout}>{literals.logout}</LogoutButton>
              ) : null}
            </Breadcrumb>
            {
              creationThinkSeed && this.printCreationThinkSeed()
            }
          </Toolbar>
        </AppHeader>
      </React.Fragment>
    );
  }
}

Navbar.propTypes = {
  navbarData: PropTypes.object.isRequired,
  app: PropTypes.object.isRequired,
  actualContext: PropTypes.object,
  viewUserProfile: PropTypes.func.isRequired,
  literals: PropTypes.object.isRequired,
  searcher: PropTypes.bool,
  logoutVisible: PropTypes.bool,
  creationThinkSeed: PropTypes.bool,
};

Navbar.defaultProps = {
  searcher: false,
  logoutVisible: false,
  creationThinkSeed: false,
  actualContext: null,
};

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/Navbar/components/index.jsx